import { defineStore } from 'pinia';
import { DevelopersApi } from '@/api/Developers.api';


const useProjectVersionStore = defineStore('VersionStore', {
  state: () => ({
    versions: {} as Record<string, string[]>,
    nextToken: {} as Record<string, string>,
  }),

  getters: {
    projectVersions: (state) => {
      return (projectName) => state.versions[projectName] || null;
    },
    projectNextToken: (state) => {
      return (projectName) => state.nextToken[projectName] || null;
    },
  },

  actions: {
    async getProjectVersions(projectName: string): Promise<void> {
      const res = await DevelopersApi.getProjectVersions(projectName);
      this.versions[projectName] = res.dir;
    },

    async scrollProjectVersions(projectName: string, nextToken: string): Promise<void> {
      const res = await DevelopersApi.getBatchProjectVersionsList(projectName, nextToken);
      this.versions[projectName] = res.dir;
      this.nextToken[projectName] = res.nextToken || 'end';
    },

    async deleteProjectVersion(projectName: string, version: string): Promise<void> {
      this.versions[projectName] = this.versions[projectName].filter(i => i !== version);
      await DevelopersApi.deleteVersion(projectName, version);
    },
  },
});

export default useProjectVersionStore;
